<script>
export default {
};
</script>

<template>
  <div style="text-align: center;">
    <b-spinner
        type="grow"
        class="m-2"
        variant="primary"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="secondary"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="success"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="info"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="warning"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="danger"
        role="status"
    ></b-spinner>
    <b-spinner
        type="grow"
        class="m-2"
        variant="dark"
        role="status"
    ></b-spinner>
  </div>
  <!-- end card -->
</template>